import React from "react";
import "../css/footer.css";
import AlmaEconomicsLogo from "../images/almaeconomics_logo.svg";
import SocialCareWalesLogo from "../images/socialcarewales_logo.svg";

function Footer() {
	const year = new Date().getFullYear();
	return (
		<div>
			<footer className="footer-container">
				<div>
					<div className="footer-left-section">
						<a
							href="https://socialcare.wales"
							target="_blank"
							rel="noreferrer"
						>
							<img
								src={SocialCareWalesLogo}
								alt="Social Care Wales Logo"
							/>
						</a>
					</div>
					<div className="footer-middle-section">
						<span>
							Copyright © {year} All rights reserved <br />
						</span>
						<span>
							<span>
								<b>
									Let's connect:
									<br />
								</b>
							</span>
							<div id="socials-container">
								<a
									href="mailto:info@almaeconomics.com"
									target="_blank"
									rel="noopener noreferrer"
								>
									Email
								</a>
								<a
									href="https://www.almaeconomics.com"
									target="_blank"
									rel="noopener noreferrer"
								>
									Website
								</a>
								<a
									href="https://www.linkedin.com/company/alma-economics/"
									target="_blank"
									rel="noopener noreferrer"
								>
									LinkedIn
								</a>
								<a
									href="https://twitter.com/almaeconomics"
									target="_blank"
									rel="noopener noreferrer"
								>
									Twitter
								</a>
								<a
									href="https://www.facebook.com/people/Alma-Economics/100083371470933/"
									target="_blank"
									rel="noopener noreferrer"
								>
									Facebook
								</a>
								<a
									href="https://www.instagram.com/alma_economics/"
									target="_blank"
									rel="noopener noreferrer"
								>
									Instagram
								</a>
								<br />
							</div>{" "}
						</span>
					</div>
					<div className="footer-right-section">
						<a
							href="https://www.almaeconomics.com/"
							target="_blank"
							rel="noreferrer"
						>
							<img
								src={AlmaEconomicsLogo}
								alt="Alma Economics Logo"
							/>
						</a>
					</div>
				</div>
			</footer>
			<footer className="footer-container-mobile">
				<div className="footer-middle-section">
					<span>
						<span>
							<b>
								Let's connect:
								<br />
							</b>
						</span>
						<div id="socials-container">
							<a
								href="mailto:info@almaeconomics.com"
								target="_blank"
								rel="noopener noreferrer"
							>
								Email
							</a>
							<a
								href="https://www.almaeconomics.com"
								target="_blank"
								rel="noopener noreferrer"
							>
								Website
							</a>
							<a
								href="https://www.linkedin.com/company/alma-economics/"
								target="_blank"
								rel="noopener noreferrer"
							>
								LinkedIn
							</a>
							<a
								href="https://twitter.com/almaeconomics"
								target="_blank"
								rel="noopener noreferrer"
							>
								Twitter
							</a>
							<a
								href="https://www.facebook.com/people/Alma-Economics/100083371470933/"
								target="_blank"
								rel="noopener noreferrer"
							>
								Facebook
							</a>
							<a
								href="https://www.instagram.com/alma_economics/"
								target="_blank"
								rel="noopener noreferrer"
							>
								Instagram
							</a>
							<br />
						</div>{" "}
					</span>
				</div>
				<div className="footer-logo-section">
					<div className="footer-left-section">
						<a
							href="https://socialcare.wales"
							target="_blank"
							rel="noreferrer"
						>
							<img
								src={SocialCareWalesLogo}
								alt="Social Care Wales Logo"
							/>
						</a>
					</div>

					<div className="footer-right-section">
						<a
							href="https://www.almaeconomics.com/"
							target="_blank"
							rel="noreferrer"
						>
							<img
								src={AlmaEconomicsLogo}
								alt="Alma Economics Logo"
							/>
						</a>
					</div>
				</div>
			</footer>
		</div>
	);
}

export default Footer;
